import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/404',
    name: '404',
    component: () => lazyLoadView(import('@layouts/404')),
  },
  {
    path: '/sesi-habis',
    name: 'sesi-habis',
    component: () => lazyLoadView(import('@layouts/SesiHabis')),
  },
  {
    path: '/auth',
    component: () => lazyLoadView(import('@views/auth/Main')),
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => lazyLoadView(import('@views/auth/Login')),
        meta: {
          title: 'Login',
          layouts: 'Layout',
        },
      },
      {
        path: 'forget',
        name: 'forget',
        component: () => lazyLoadView(import('@views/auth/Forget')),
        meta: {
          title: 'Lupa Password',
          layouts: 'Layout',
        },
      },
      {
        path: 'aktivasi',
        name: 'aktivasi',
        component: () => lazyLoadView(import('@views/auth/Aktivasi')),
        meta: {
          title: 'Aktivasi',
          layouts: 'Layout',
        },
      },
    ],
  },
  {
    path: '/daftar',
    name: 'daftar',
    component: () => lazyLoadView(import('@views/auth/Daftar')),
    meta: {
      title: 'Daftar',
      layouts: 'Layout',
    },
  },
  {
    path: '/berlangganan',
    name: 'berlangganan',
    component: () => lazyLoadView(import('@views/admin/Berlangganan')),
    meta: {
      title: 'Berlangganan',
    },
  },
];
